import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { setAssetTypeLabels } from 'utils/Asset';

import assetTypeLabelsQuery from './assetTypeLabels.graphql';

export default function useAssetTypeLabels() {
  const { data } = useQuery<AssetTypeLabelsQuery>(assetTypeLabelsQuery, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (data?.assetTypeLabels) {
      setAssetTypeLabels(data.assetTypeLabels);
    }
  }, [data]);
}
